import { useEffect } from 'react'
import { type UseFormSetValue } from 'react-hook-form'
import { useIntl } from 'react-intl'

import {
  RXPrescriptionRequestV1TitleEnum,
  SalutationV1,
} from '@redteclab/api/clients/bully'

import { useApiSwrGetCustomerData } from '../../../../user-data'
import { type RxLpChMainFormFields } from '../types'

const salutationToEnum = (
  salutation: SalutationV1,
): RXPrescriptionRequestV1TitleEnum => {
  if (salutation === SalutationV1.Mrs) {
    return RXPrescriptionRequestV1TitleEnum.ChrxQuestionnairePronounsMrs
  }

  return RXPrescriptionRequestV1TitleEnum.ChrxQuestionnairePronounsMr
}

export const usePrefillRxFormUserData = (
  setValue: UseFormSetValue<RxLpChMainFormFields>,
): void => {
  const intl = useIntl()
  const { data: userData } = useApiSwrGetCustomerData()

  useEffect(() => {
    if (!userData) {
      return
    }

    const parsedBirthDate = intl.formatDate(userData.dateOfBirth)

    setValue('firstname', userData.firstName)
    setValue('lastname', userData.lastName)
    setValue('email', userData.email)
    setValue('birthdate', parsedBirthDate)
    setValue('phone', userData.phone)

    setValue('street', userData.billingAddress.street ?? '')
    setValue('streetNo', userData.billingAddress.streetNo ?? '')
    setValue('city', userData.billingAddress.city ?? '')
    setValue('zip', userData.billingAddress.zip ?? '')

    setValue('title', salutationToEnum(userData.salutation))
  }, [userData, setValue, intl])
}
